'use client';

import React, { useEffect, useState } from 'react';

import { VStack } from '@chakra-ui/react';
import dayjs from 'dayjs';

import { CustomText } from '@components/Custom-text';
import DateFilter from '@components/Date-filter/DateFilter';
import { useAppDispatch, useAppSelector } from '@hooks/store';
import { setFindMentorFilters } from '@modules/find-mentor/slice';

const AvailabilityFilter = () => {
    const { fromDate, toDate } = useAppSelector(state => state.reducer.mentorFilters);
    const [from, setFrom] = useState<string>('');
    const [to, setTo] = useState<string>('');
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (from !== '' && to !== '') {
            dispatch(
                setFindMentorFilters({
                    fromDate: dayjs(from).toISOString(),
                    toDate: dayjs(to).toISOString(),
                })
            );
        }
    }, [dispatch, from, to]);

    useEffect(() => {
        if (fromDate === '' || toDate === '') {
            setFrom('');
            setTo('');
        }
    }, [fromDate, toDate]);
    return (
        <VStack width="100%" align="flex-start">
            <CustomText color="mainText" weight={500} size="md" marginBottom="10px">
                Availability
            </CustomText>
            <DateFilter
                fromLabel="From"
                toLabel="To"
                setFrom={setFrom}
                setTo={setTo}
                from={from}
                to={to}
                minFrom={dayjs().format('YYYY-MM-DD')}
            />
        </VStack>
    );
};

export default AvailabilityFilter;
